import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";
import { MaterialReactTable } from "material-react-table";
import TsumuraKampoData from "data/tsumura-kampo.json";

function TsumuraKampo() {
  const columns = useMemo(
    () => [
      {
        accessorKey: "product_no",
        header: "製品No.",
        filterVariant: "range",
      },
      {
        accessorKey: "name",
        header: "名前",
      },
      {
        accessorKey: "kana",
        header: "カナ",
      },
      {
        accessorKey: "set",
        header: "生薬",
      },
    ],
    []
  );

  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <MaterialReactTable
          columns={columns}
          data={TsumuraKampoData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection={false}
          initialState={{ 
            density: "compact",
            pagination: { pageSize: 20, pageIndex: 0 }
          }}
          renderTopToolbarCustomActions={() => (
            <Typography paragraph style={{ margin: 0 }}>ツムラ医療用漢方製剤</Typography>
          )}
        />
      </div>
    </ResponsiveDrawer>
  );
}

export default TsumuraKampo;
